import { Subtenant } from '@bioliberty/lifemind';
import { useMemo } from 'react';
import { useAuthentication } from '../auth';

export function useActiveSubtenants(): Subtenant[] | undefined {
  const currentUser = useAuthentication();
  return useMemo(() => currentUser.subtenants?.filter((s) => !s.inactive), [currentUser.subtenants]);
}
